<template>
    <div class="pagination-controls mt-3">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span class="pagination-info">
                Showing {{ startItem }}–{{ endItem }} of {{ total }}
            </span>
            <div class="d-flex align-items-center gap-1">
                <button class="page-btn" :disabled="page <= 1" @click="$emit('page-change', 1)" title="First">&laquo;</button>
                <button class="page-btn" :disabled="page <= 1" @click="$emit('page-change', page - 1)" title="Previous">&lsaquo;</button>
                <span class="page-indicator">Page {{ page }} of {{ totalPages }}</span>
                <button class="page-btn" :disabled="page >= totalPages" @click="$emit('page-change', page + 1)" title="Next">&rsaquo;</button>
                <button class="page-btn" :disabled="page >= totalPages" @click="$emit('page-change', totalPages)" title="Last">&raquo;</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaginationControls',
    props: {
        page: { type: Number, required: true },
        totalPages: { type: Number, required: true },
        total: { type: Number, required: true },
        perPage: { type: Number, required: true },
    },
    emits: ['page-change'],
    computed: {
        startItem() {
            return Math.min((this.page - 1) * this.perPage + 1, this.total);
        },
        endItem() {
            return Math.min(this.page * this.perPage, this.total);
        },
    },
};
</script>

<style scoped>
.pagination-controls {
    padding: 8px 0;
}
.pagination-info {
    font-size: 0.8rem;
    color: #9ca3af;
}
.page-btn {
    background: rgba(30, 30, 46, 0.8);
    border: 1px solid rgba(139, 92, 246, 0.3);
    border-radius: 4px;
    color: #e5e7eb;
    padding: 4px 10px;
    font-size: 0.85rem;
    cursor: pointer;
    min-width: 32px;
}
.page-btn:hover:not(:disabled) {
    background: rgba(139, 92, 246, 0.2);
    border-color: #8b5cf6;
}
.page-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}
.page-indicator {
    font-size: 0.8rem;
    color: #9ca3af;
    padding: 0 8px;
    white-space: nowrap;
}
</style>
